import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'; // Add this to your imports
import { Update, GetById } from '../../service/UserService';
import { GetAll } from '../../service/BloodGroupService';
import { CityGetAll } from '../../service/CityService';
import { GenderGetAll } from '../../service/GenderService';

export default function MemberEdit() {
  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser
  } = useGlobalContext();

  const id = appUser.id ;
  console.log("logged user id", id)

  const [status, setStatus] = useState('active');
  const [user, setUser] = useState({});

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [address, setAddress] = useState('');
  const [landmark, setLandmark] = useState('');
  const [pincode, setPincode] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [dob, setDob] = useState('');
  const [image, setImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setImage(file);
    console.log(file);
  };

  const fetchUserById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      console.log("res users", response);
      if (response.status === 200) {
        setUser(response.user);
        setName(response.user.name);
        setDob(response.user.dob.date.substring(0, 10));
        setEmail(response.user.email);
        setMobile(response.user.mobile);
        setImage(response.user.image);
        setStatus(response.user.status);
        setBloodGroupId(response.user.bloodGroup.id);
        setCityId(response.user.city.id);
        setGenderId(response.user.gender.id);
        setAddress(response.user.address);
        setLandmark(response.user.landmark);
        setPincode(response.user.pincode);
        setWhatsapp(response.user.whatsapp);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };


  // bloodGroup foreign key
  const [bloodGroupId, setBloodGroupId] = useState('');
  const [bloodGroups, setBloodGroups] = useState([]);
  const [keyword, setKeyword] = useState('');

  const FetchBloodGroup = async () => {
    setIsLoading(true);
    try {
      const response = await GetAll(1, 9999, keyword);
      console.log("bg", response);
      if (response && Array.isArray(response.bloodgroups)) {
        // Filter only active categories
        const activeBloodGroups = response.bloodgroups.filter(cat => cat.status === "active");
        setBloodGroups(activeBloodGroups);
      } else {
        setAppError(true);
        setAppErrorMessage('No BloodGroup Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading master data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchBloodGroup();
  }, []);


  // city foreign key
  const [cityId, setCityId] = useState('');
  const [citys, setCitys] = useState([]);
  const [cityKeyword, setCityKeyword] = useState('');

  const FetchCity = async () => {
    setIsLoading(true);
    try {
      const response = await CityGetAll(1, 9999, cityKeyword);
      console.log("city", response);
      if (response && Array.isArray(response.cities)) {
        // Filter only active cities
        const activeCities = response.cities.filter(ct => ct.status === "active");
        setCitys(activeCities);
      } else {
        setAppError(true);
        setAppErrorMessage('No Cities Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading city data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchCity();
  }, []);


  // gender foreign key
  const [genderId, setGenderId] = useState('');
  const [genders, setGenders] = useState([]);
  const [genderKeyword, setGenderKeyword] = useState('');

  const FetchGender = async () => {
    setIsLoading(true);
    try {
      const response = await GenderGetAll(1, 9999, genderKeyword);
      if (response && Array.isArray(response.genders)) {
        // Filter only active genders
        const activeGenders = response.genders.filter(gender => gender.status === "active");
        setGenders(activeGenders);
      } else {
        setAppError(true);
        setAppErrorMessage('No Genders Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading gender data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchGender();
  }, []);

  // end of foreign key fetch


  const saveMember = async (event) => {
    event.preventDefault();

    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }

    if (!dob) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Date of Birth is required");
      setAppErrorMode("error");
      return;
    }

    setIsLoading(true);

    try {
      const response = await Update(id, name, mobile, email, image, dob, genderId, cityId, bloodGroupId, address, landmark, whatsapp, pincode);    
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "My Profile updated successfully");
        setAppErrorMode("success");
        window.location.href = "/myprofile";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to update profile. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to update profile. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchUserById();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>My Profile Manage | {config.appName}</title>
      </Helmet>

      <div className="container">
        <div className="page">
          <div className="page-heading">
            <h1>My Profile Update</h1>
            <span>
              <Link to="/"> Dashboard </Link>  / My Profile Manage
            </span>
          </div>

          <div className="page-content">
            <div className="portal">
              <div className="portal-body">
                <form onSubmit={saveMember} encType='multipart/form-data'>
                  <div className="row">

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          className='form-control'
                          type='text'
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Date of Birth</label>
                        <input
                          className='form-control'
                          type='date'
                          value={dob}
                          onChange={(e) => setDob(e.target.value)}
                        />
                      </div>
                    </div>

                    {/* City Dropdown */}
                    <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">City</label>
                        <select
                          className="form-control"
                          value={cityId}
                          onChange={(e) => setCityId(e.target.value)}
                        >
                          <option value="">Select City</option>
                          {citys.map(cityOption => (
                            <option key={cityOption.id} value={cityOption.id}>
                              {cityOption.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-3 col-sm-12 mb-3">
                      <label>Gender </label>
                      <div>
                        {genders.map((gender) => (
                          <span key={gender.id}>
                            <input
                              type="radio"
                              name="gender"
                              value={gender.id}
                              checked={genderId === gender.id}
                              onChange={() => setGenderId(gender.id)}
                            />{" "}
                            {gender.name} &nbsp;
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* Blood Group Dropdown */}
                    <div className='col-lg-3 col-md-6 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Blood Group</label>
                        <select
                          className="form-control"
                          value={bloodGroupId}
                          onChange={(e) => setBloodGroupId(e.target.value)}
                        >
                          <option value="">Select Blood Group</option>
                          {bloodGroups.map(bloodGroupOption => (
                            <option key={bloodGroupOption.id} value={bloodGroupOption.id}>
                              {bloodGroupOption.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          className='form-control'
                          type='email'
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Mobile</label>
                        <input
                          className='form-control'
                          type='number'
                          value={mobile}
                          onChange={(e) => setMobile(e.target.value)}
                        disabled />
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Whatsapp</label>
                        <input
                          className='form-control'
                          type='number'
                          value={whatsapp}
                          onChange={(e) => setWhatsapp(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='col-lg-6 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          className='form-control'
                          type='text'
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='col-lg-6 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Landmark</label>
                        <input
                          className='form-control'
                          type='text'
                          value={landmark}
                          onChange={(e) => setLandmark(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Pincode</label>
                        <input
                          className='form-control'
                          type='number'
                          value={pincode}
                          onChange={(e) => setPincode(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className='col-lg-5 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                        <label className="form-label">Image</label>
                        <input
                          className='form-control'
                          type='file'
                          onChange={handleFileChange}
                        />
                        
                      </div>
                    </div>
                     <div className='col-lg-1 col-md-4 col-sm-6 col-12'>
                      <div className="mb-3">
                         {user?.id && user?.image && (
                          <img
                            src={`${config.imageBasePath}/user/${user.id}.${user.image}`}
                            alt={user.name}
                            className='img-fluid image-xs profile-img'
                            style={{ width: '100px', marginTop: '10px', height: '55px' }}
                          />
                        )}
                      </div>
                    </div>
                    
                    <div className='clearfix'></div>
                    <div className='col-12 text-end'>
                      <div className="mb-3">
                        <button type='reset' className='btn btn-danger btn-md'>
                          <i className="ri-reset-right-line"></i> Reset
                        </button>
                        &nbsp;&nbsp;
                        <button type='submit' className='btn btn-success btn-md'>
                          <i className="ri-check-fill"></i> Update Profile
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};